const customheaders = `{
  "headers": {
      'Accept-Language': 'en-US'
  }
}`;

export default customheaders;
